import { render, staticRenderFns } from "./OrionTaxLots.vue?vue&type=template&id=0b7e2a1e&"
import script from "./OrionTaxLots.vue?vue&type=script&lang=js&"
export * from "./OrionTaxLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports